import { Container } from "@mantine/core";
import * as React from "react";

import type { User } from "@/api/auth";
import { Navbar } from "@/shared/navbar";
import type { QueryClient } from "@tanstack/react-query";
import { Outlet, createRootRouteWithContext } from "@tanstack/react-router";
import { Toaster } from "sonner";

type TRootContext = {
	queryClient: QueryClient;
	isAuthenticated: boolean;
	user: User | null;
};

export const Route = createRootRouteWithContext<TRootContext>()({
	component: RootComponent,
});

const TanStackRouterDevtools = import.meta.env.PROD
	? () => null // Render nothing in production
	: React.lazy(() =>
			// Lazy load in development
			import("@tanstack/router-devtools").then((res) => ({
				default: res.TanStackRouterDevtools,
				// For Embedded Mode
				// default: res.TanStackRouterDevtoolsPanel
			})),
		);

const TanstackQueryDevtools = import.meta.env.PROD
	? () => null
	: React.lazy(() =>
			import("@tanstack/react-query-devtools").then((res) => ({
				default: res.ReactQueryDevtools,
			})),
		);

function RootComponent() {
	return (
		<>
			<Navbar />
			<Container size="xl" pt="xl">
				<Outlet />
			</Container>
			<Toaster position="bottom-right" richColors />
			<React.Suspense>
				<TanStackRouterDevtools position="bottom-left" />
				<TanstackQueryDevtools />
			</React.Suspense>
		</>
	);
}
